import React from 'react';
import PlanterGardenImageComponent from "./PlanterGardenImageComponent";
import '../css/PlanterGardenComponentStyling.css';

const PlanterGardenComponent = ({ gardenName, gardenMatrix, gardenHardiness, gardenSoilType, gardenSunlight, gardenMaintenance, planted, selected, saved, badgeButtonClick }) => {
    let totalSpace = gardenMatrix.split('\n').map(row => row.split(',').map(Number)).flat().reduce((acc, curr) => acc + curr, 0);
    let isSelectedFirst = selected && !planted;
    let isSelectedAndPlanted = selected && planted;

    const handleButtonClick = () => {
        badgeButtonClick(gardenName);
    }

    return (
        <div className={`planter-garden-card ${selected ? 'selectedGarden' : ''}`}>
            <div className="garden-image-wrapper">
                <PlanterGardenImageComponent gardenMatrix={gardenMatrix} />
            </div>
            <div className="garden-info">
                <h3>{gardenName}</h3>
                <p> {gardenSunlight} | {gardenSoilType} soil</p>
                <p> {totalSpace} ft&sup2; | {Math.round(totalSpace / 4)} plants</p>

                <div className={`pgic-planted-badge ${planted ? 'planted' : ''}`} onClick={handleButtonClick}>
                    <p
                        data-default={
                            saved
                                ? 'Garden Finalized!'
                                : planted && !isSelectedAndPlanted
                                    ? 'Plants Selected'
                                    : isSelectedAndPlanted
                                        ? 'Planting Garden'
                                        : isSelectedFirst
                                            ? 'Selecting Veggies'
                                            : 'Begin planting'
                        }
                        data-hover={
                            saved
                                ? 'Garden Finalized!'
                                : planted && !isSelectedAndPlanted
                                    ? 'Ready to Plant!'
                                    : isSelectedAndPlanted
                                        ? 'Finish Garden'
                                        : isSelectedFirst
                                            ? 'Selecting Veggies'
                                            : 'Start!'
                        }
                    />
                </div>


            </div>
        </div>
    );
};

export default PlanterGardenComponent;